export type UniqueDropNameMode = 'pathSegment' | 'rootFile';

function parseStemAndStartNum(displayName: string): { stem: string; startN: number } {
  const m = displayName.match(/^(.+?)\s+(\d+)$/);
  if (m) {
    return { stem: m[1], startN: parseInt(m[2], 10) + 1 };
  }
  return { stem: displayName, startN: 2 };
}

function isFree(usedLowercase: Set<string>, name: string): boolean {
  return !usedLowercase.has(name.toLowerCase());
}

function claim(usedLowercase: Set<string>, name: string): void {
  usedLowercase.add(name.toLowerCase());
}

/**
 * Hedefte veya aynı drop içinde çakışmayı önlemek için üst seviye ad üretir.
 * pathSegment: klasör kökü (path'in ilk segmenti), rootFile: kök dosya adı (uzantı korunur).
 */
export function allocateUniqueDropName(
  desired: string,
  usedLowercase: Set<string>,
  mode: UniqueDropNameMode
): string {
  if (mode === 'pathSegment') {
    if (isFree(usedLowercase, desired)) {
      claim(usedLowercase, desired);
      return desired;
    }
    const { stem, startN } = parseStemAndStartNum(desired);
    for (let n = startN; ; n++) {
      const candidate = `${stem} ${n}`;
      if (isFree(usedLowercase, candidate)) {
        claim(usedLowercase, candidate);
        return candidate;
      }
    }
  }

  const lastDot = desired.lastIndexOf('.');
  const extPart = lastDot > 0 ? desired.slice(lastDot) : '';
  const fileBase = lastDot > 0 ? desired.slice(0, lastDot) : desired;

  if (isFree(usedLowercase, desired)) {
    claim(usedLowercase, desired);
    return desired;
  }
  const { stem, startN } = parseStemAndStartNum(fileBase);
  for (let n = startN; ; n++) {
    const candidate = `${stem} ${n}${extPart}`;
    if (isFree(usedLowercase, candidate)) {
      claim(usedLowercase, candidate);
      return candidate;
    }
  }
}

export function dropTopLevelModeForName(
  topLevel: string,
  items: { relativePath: string }[]
): UniqueDropNameMode {
  const hasFolder = items.some((i) => {
    if (!i.relativePath.includes('/')) return false;
    return (i.relativePath.split('/')[0] ?? '') === topLevel;
  });
  return hasFolder ? 'pathSegment' : 'rootFile';
}
